const SNAKE_CASE_MATCH = /_\w/g;

/**
 * Converts an underscore_string to a camelCase string
 */
export const snakeToCamel = (key: string) =>
    key.replace(SNAKE_CASE_MATCH, (chars) => chars[1].toUpperCase());
